export default {
  lotteryId: '',
  token: '',
  mobile: '',
  backgroud: '',
  rule: '',
  title: '',
  adNum: '',
};
